<template>
    <v-footer
      color="white"
      height="auto"
    >
      <v-card
        fluid
        tile
        class="indigo lighten-1 white--text text-center"
        color="primary"
        width="100%"
      >
          <v-container>
            <h3>Siguenos en nuestras redes</h3>
            <v-row>
              <v-col
                cols="12"
                md="12"
              >
                <v-avatar
                v-for="({ img, title, url }, i) in features"
                :key="i"
                color="secondary"
                size="40"
                style="margin: 5px;"
                >
                  <a :href="url">
                    <v-img
                    max-height="40" 
                    max-width="40" 
                    style="border-radius: 100%; " 
                    :src="img"
                    >
                    </v-img>
                  </a>
                </v-avatar>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-card-text class="white--text pt-0">
                  <ul>
                    <li>
                      <a href="/">
                        Inicio
                      </a>
                    </li>
                    <li>
                      <a href="/bar">
                        Bar
                      </a>
                    </li>
                    <li>
                      <a href="/bar">
                        Café
                      </a>
                    </li>
                    <li>
                      <a href="/bar">
                        Contacto
                      </a>
                    </li>
                  </ul>
                </v-card-text>
              </v-col>
              <v-col cols="12" md="4"
              >
                <v-card-text class="white--text pt-0">
                  Phasellus feugiat arcu sapien, et iaculis ipsum elementum sit amet. Mauris cursus commodo interdum. Praesent ut risus eget metus luctus accumsan id ultrices nunc. Sed at orci sed massa consectetur dignissim a sit amet dui. Duis commodo vitae velit et faucibus. Morbi vehicula lacinia malesuada. Nulla placerat augue vel ipsum ultrices, cursus iaculis dui sollicitudin. Vestibulum eu ipsum vel diam elementum tempor vel ut orci. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
                </v-card-text>
              </v-col>
              <v-col cols="12" md="4"
              >
                <v-card-text class="white--text pt-0">
                   <ul>
                    <li>
                      <a href="/">
                        Dirección: Carretera Arta N°38 07400 Alcudia
                      </a>
                    </li>
                    <li>
                      <a href="/bar">
                        Teléfono: +34 971 15 89 23
                      </a>
                    </li>
                    <li>
                      <a href="/bar">
                        Email: fiorelladipietro@hotmail.com
                      </a>
                    </li>
                  </ul>
                </v-card-text>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="12">
                <v-card-text class="white--text">
                  &copy; {{ year }} — <strong>Manduca Café Bar</strong> - 
                  Desarrollado por  <strong><a href="https://dev.tedesco.es" style="text-decoration: none; color:white;" target="_blank" rel="noopener">Tedesco Dev</a></strong>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        
        
      </v-card>
    </v-footer>
</template>
<script>
export default {
    name: 'Footer',
  data: () => ({
    url: "https://github.com/mbj36",
    icons: [
      'fast_forward',
      'fiber_dvr',
      'featured_play_list',
      'fiber_pin',
      'fiber_smart_record'
    ],
    features: [
      {
        img: require('../assets/wathsappIconColor.png'),
        title: 'WhatSapp',
        url: 'https://api.whatsapp.com/send?phone=34622727733',
      },
      {
        img: require('../assets/facebookIconColor.png'),
        title: 'Facebook',
        url: 'https://web.facebook.com/Manduca-Caf%C3%A9-Bar-358467741717806/',
      },
      {
        img: require('../assets/instagramIconColor.png'),
        title: 'Instagram',
        url: 'Lorem Ipsum is simply dummy url of the printing and typesetting industry. ',
      },
      {
        img: require('../assets/twitterIconColor.png'),
        title: 'Twitter',
        url: 'Lorem Ipsum is simply dummy url of the printing and typesetting industry. ',
      }
    ],
    year: new Date().getFullYear()
  }),
}
</script>
<style lang="scss" scoped>
ul {
list-style: none; /* Quitamos los marcadores */
padding-left: 0px !important;
}

li {
  list-style: none;
  padding: 18px;
}

a {
  color: white !important;
  text-decoration: none;
}
</style>